<template>
  <div class="head" v-if="this.$route.path!='/printTransportTicket'">
    <div class="content">
      <div class="content-item" v-if="$route.path!='/home'" @click="$router.push('/home')">
        首页
      </div>
      <div class="content-item" v-else></div>
      <div v-if="!isLogin" class="content-item">
        <div @click="$router.push('/login?role=DRIVER_CARRIER')">承运商登录</div>
        <div style="margin-left:20px" @click="$router.push('/login?role=CUSTOMER')">货主登录</div>
        <div style="margin-left:20px" @click="openManagement">平台登录</div>
      </div>
      <div v-else class="content-item">
        <span @click="jump">{{ userName }}</span>
        <span style="margin-left:20px" @click="logout">退出</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      name: "",
    };
  },
  computed: {
    ...mapState(["isLogin", "userName"]),
  },
  methods: {
    logout() {
      this.$store.commit("logout");
      sessionStorage.clear()
      localStorage.clear()
      location.reload();
    },
    jump() {
      let role = JSON.parse(localStorage.getItem("userInfo")).currentRole;
      if (role == "CARRIERS") {
        this.$router.push("/carriers");
      }
      if (role == "CUSTOMER") {
        this.$router.push("/consignor");
      }
      if (role == "DRIVER") {
        this.$router.push("/driver");
      }
    },
    openManagement(){
      window.location.href='http://nettransport.yyth.com.cn/admin/'
    }
  },
  created() {},
  mounted() {},
};
</script>
<style scoped lang="less">
.head {
  width: 100%;
  height: 40px;
  background: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  z-index: 9;
  .content {
    width: 1200px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .content-item {
      margin-left: 30px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
